import React from 'react';
import { bool, node, object, oneOf } from 'prop-types';
import { Alert } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const Banner = ({
  severity, variant, action, children, hideIcon, styles, bannerProps,
}) => {
  const props = {
    ...(hideIcon ? { icon: false } : {}),
    ...(severity === 'gated' ? {
      icon: <LockOutlinedIcon fontSize="inherit" />,
    } : {}),
    ...bannerProps,
  };
  return (
    <Alert
      severity={severity === 'gated' ? 'warning' : severity}
      variant={variant}
      action={action}
      sx={styles}
      {...props}
    >
      {children}
    </Alert>
  );
};

export default Banner;

Banner.propTypes = {
  action: node,
  children: node.isRequired,
  largePadding: bool,
  severity: oneOf(['error', 'info', 'success', 'warning', 'gated']),
  hideIcon: bool,
  variant: oneOf(['filled', 'outlined']),
  styles: object,
  bannerProps: object,
};

Banner.defaultProps = {
  action: null,
  largePadding: false,
  severity: 'info',
  hideIcon: false,
  variant: 'outlined',
  styles: {},
  bannerProps: {},
};
